import type { ReactNode } from 'react';
import styled from 'styled-components';
import { Text, theme } from '@frameio/vapor';
import { GLPYHS } from '../../../../constants';

type ListItemDetailRowProps = {
  leftSegment?: ReactNode;
  middleSegment?: ReactNode;
  rightSegment?: ReactNode;
};

type SegmentProps = {
  content?: ReactNode;
  hasBullet?: boolean;
};

const Segment = ({ content, hasBullet = false }: SegmentProps) => {
  if (!content) return null;

  return (
    // Avoid extra wrapping DOM element to ensure
    // parent's flex `gap` correctly spaces bullet and content
    <>
      {hasBullet && <Bullet>{GLPYHS.bullet}</Bullet>}
      {content}
    </>
  );
};

export const ListItemDetailRow = ({
  leftSegment,
  middleSegment,
  rightSegment,
}: ListItemDetailRowProps) => {
  return (
    <DetailRowContainer>
      <Segment content={leftSegment} />
      <Segment content={middleSegment} hasBullet={!!leftSegment} />
      <Segment content={rightSegment} hasBullet={!!middleSegment} />
    </DetailRowContainer>
  );
};

const DetailRowContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  gap: ${theme.spaces[4]};
  max-height: 20px;
  min-width: 100%;
  white-space: nowrap;

  /* Target all direct children that are the last child */
  > :last-child:not(:has(${GLPYHS.bullet})) {
    flex: 1;
  }

  /* Hide middle segment when container width is below 300px */
  @container list-item-detail (max-width: 300px) {
    > :nth-child(2),
    > :nth-child(3) {
      display: none;
    }
  }
`;

const Bullet = styled(Text).attrs({
  color: 'tertiary',
  variant: 'secondary',
})``;
